
const servicesUrl="https://www.fao.org/fishery/services";
const space="firms";

export const environment = {
  production: false,
  name: "Dev Environment",
  translations: {
    prefix: './assets/i18n/',
    suffix: '.json'
  },
  enabledLanguages: ["en","fr","es"],
  space: space,
  statuses: "published",
  reviewStatuses: "published,unpublished,draft",
  status: "published",
  enableLogin: false,
  servicesUrl: servicesUrl,
  securityUrl: 'https://www.fao.org/fishery/security',
  storageUrl: servicesUrl + '/storage/fs',
  siteUrl: 'https://firms.fao.org/firms',
  geoUrl: 'https://www.fao.org/fishery/geoserver/',
  faolexUrl: 'https://www.fao.org/faolex/results/details/en/c/',
  extent: [-100,-80,100,80],
  token: 'lo2g_CpemafFGpIltOACu9i8nfTsILtVVGQKwGT9Rj_zMUlyNdP4_4Y7RKwDvglh1ygPt93kqjQBWdFk3D9jSJNtVyAhFA_V9thDVgd57HxRQYvrHLsd09S6CqyIMqhN',
  defaultDateFormat:"dd/MM/yyyy",
  fisheryUrl: "https://www.fao.org/fishery"
};
